import { Button, Modal } from 'antd'

export default function DeleteCoverModal({ show, onClose, onDelete }) {
  return (
    <Modal
      open={show}
      onCancel={onClose}
      closable
      title="Delete Cover"
      footer={
        <>
          <Button className="btn-white btn-dash" onClick={onClose}>
            Cancel
          </Button>
          <Button className="btn-blue btn-dash" onClick={onDelete}>
            Delete
          </Button>
        </>
      }
    >
      <div>
        <div className="alert alert-danger">
          Are you sure you want to delete this book cover?
        </div>
      </div>
    </Modal>
  )
}
